/**
 * Created by zhengyf on 2017/10/20.
 */

;(function() {

    homeNotifyCtrl.$inject = ['request'];
    angular
        .module('DSSXAPP')
        .component('homeNotify', {
            template:'<div class="ali-index-item ali-index-item-notify-wrapper"><div class="m-notify-tab ms-ma"><div class="ms-trigger"><a class="ms-icon" href="javascript:;"><img ng-src="{{vm.avatar}}"></a><div class="ms-title-top"><span class="sc-number">0</span></div><div class="ms-title"><a href="/" target="_blank">My Alibaba</a></div></div><div class="ms-pannel"><div class="ms-group-sign"><div class="ms-title"><div class="ms-act" ng-click="vm.f.signOut()"><a href="javascript:;">Sign Out</a></div><div class="ms-info"><div class="name"><span>Hi</span> <span ng-bind="vm.nickName" ng-attr-title="{{vm.nickName}}">null</span></div></div></div><div class="ms-icon-desc"></div><ul class="ms-notify-number"><li class="ms-msg"><a href="rfq-index.html" target="_blank"><span class="text">New RFQs</span> <span class="num">0</span></a></li><li class="ms-msg"><a href="javascript:;"><span class="text">New BizClub Notices</span> <span class="num">0</span></a></li><li class="ms-msg"><a href="inquiry-manage.html" target="_blank"><span class="text">New Inquiries</span> <span class="num">0</span></a></li></ul></div><a class="ms-maentry" href="/" target="_blank">My Alibaba <i class="iconfont icon-next"></i></a> <a class="ms-maentrys" href="javascript:;">My Orders</a> <a class="ms-maentrys" href="inquiry-manage.html" target="_blank">Message Center</a> <a class="ms-maentrys" href="javascript:;">Manage RFQ</a> <a class="ms-maentrys" href="business-profile.html" target="_blank">Biz Club</a> <a class="ms-maentrys" href="account-center.html" target="_blank">My Account</a> <a class="ms-maentrys" href="javascript:;">My Favorites</a> <a class="ms-maentrys" href="javascript:;">Trade Alert</a><div class="ms-line"></div><a class="ms-maentrys" href="javascript:;">Submit RFQ</a><div class="malabel">Get multiple quotes within 24 hours!</div></div></div><div class="m-notify-tab ms-order"><div class="ms-trigger"><a class="ms-icon i-order" href="javascript:;"></a><div class="ms-title-top"><span class="sc-number">0</span></div><div class="ms-title"><a href="javascript:;">Orders</a></div></div></div><div class="m-notify-tab ms-favorite"><div class="ms-trigger"><a class="ms-icon i-favorite" href="javascript:;"></a><div class="ms-title-top"><span class="sc-number">0</span></div><div class="ms-title"><a href="javascript:;">Favorites</a></div></div></div></div>',
            bindings: {

            },
            controllerAs: 'vm',
            controller: homeNotifyCtrl
        });

    function homeNotifyCtrl(request) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        vm.avatar = '';
        vm.nickName = '';
        vm.f = {
            signOut: signOut
        };

        function onInit() {
            setUinfo();
        }

        function bindingsOnChanges(changes) {

        }

        function setUinfo() {
            vm.avatar = DSSX.util.safe(DSSX, 'currUser.usr.attrs.basic.avatar', 'images/common/default-avatar.png');
            vm.nickName = DSSX.util.safe(DSSX, 'currUser.usr.attrs.basic.nickName', 'null');
        }


        function signOut() {

            request.get(DSSX.host.protocol + '//' + DSSX.host.sso + '/sso/api/logout', {}, true)
                .then(callback, errCallback);

            function callback(rs) {
                location.href = DSSX.host.protocol + '//' + DSSX.host.sso + '/sso/?url=' + encodeURIComponent(DSSX.host.protocol + '//' + DSSX.host.main);
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'notify.js',
                    funcName: 'signOut',
                    text: '注销登录失败'
                });
            }

        }

    }

})();
